<template>
  <div class="tutorial-button">
    <button
      v-for="(cta, index) in content"
      :key="cta.label"
      :class="'btn-secondary-' + cta.color"
      @click="action(type, index)"
    >
      {{ cta.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'TutorialButton',
  props: {
    action: {
      type: Function
    },
    content: {
      type: Array
    },
    type: {
      type: String,
      default: 'cta'
    }
  }
}
</script>

<style lang="scss">
  .tutorial-button {
    display: flex;

    button {
      margin-right: 2em;
      padding: 12px 32px;
      margin-top: 22px;
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      line-height: 1;
      font-size: 12px;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      border-width: 1px;
      border-radius: 3px;
      
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
</style>
